import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  InputGroup,
  FormControl,
} from "react-bootstrap";
import { BsSearch } from "react-icons/bs";
import { useSelector, useDispatch } from "react-redux";
import {
  getUserByAccountID,
  switchAccount,
  clearStatesAction,
} from "../Redux/Auth/actions";
import { clearAuthToken } from "../tokenHandler";
import { lineSpinner } from "ldrs";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom"

export default function AccountSearch() {
  const dispatch = useDispatch();
  const abortControllerRef = useRef(null);
  const navigate = useNavigate()
  lineSpinner.register();
  const user = useSelector((state) => state?.authReducer?.data);
  const data = useSelector((state) => state?.authReducer?.accountIdData);
  const Error = useSelector((state) => state?.authReducer?.accountIdDataError);
  const [searchedID, setSearchedID] = useState();
  const [spinner, setSpinner] = useState();

  const handleClickSearch = async (searchedID) => {
    if (searchedID) {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      abortControllerRef.current = new AbortController();
      let res = await getUserByAccountID(
        dispatch,
        searchedID,
        abortControllerRef.current.signal,
      );
      await new Promise((resolve) => setTimeout(resolve, 2000));
      if (res) {
        setSpinner(false);
      }
    }
  };

  useEffect(() => {
    if (searchedID) {
      clearStatesAction(dispatch);
      setSpinner(true);
      handleClickSearch(searchedID);
    } else {
      clearStatesAction(dispatch);
      setSpinner(false);
    }

    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [searchedID]);

  const handleSwitchAccount = async (item) => {
   const res= await switchAccount(dispatch, item);
    if (res?.response==="success"){
     navigate('/')
    }
  };
  useEffect(() => {
    clearStatesAction(dispatch);
  }, [dispatch]);

  const handleClickLogout = () => {
    clearAuthToken();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  return (
    <Container className="vh-100" fluid>
      <Row className="d-flex justify-content-end align-items-center mt-2 mr-4">
        <Col>
          <Link to="/" className="border rounded-pill p-2 ">
            Go to Home
          </Link>
        </Col>
        <Col className="d-flex justify-content-end align-items-center">
          <strong className=" mr-2 ">{user?.email}</strong>
          <Button className="custom-button-signout" onClick={handleClickLogout}>
            Sign out
          </Button>
        </Col>
      </Row>
      <Row className="h-75">
        <Col className="d-flex flex-column justify-content-center align-items-center ">
          <h3 className="custom-p-tag" style={{ textTransform: "uppercase" }}>
            Welcome to support center
          </h3>
          <Form className="w-50">
            <Form.Group className="mb-3" controlId="formPlaintextEmail">
              <InputGroup className="custom-border-input-search shadow">
                <InputGroup.Text className="custom-search-icon">
                  <BsSearch style={{ cursor: "pointer" }} />
                </InputGroup.Text>
                <FormControl
                  type="search"
                  placeholder="Search Account"
                  name="accountID"
                  className="custom-border-searchBar"
                  style={{ border: "none" }}
                  onChange={(e) => setSearchedID(e.target.value)}
                  onKeyDown={handleKeyDown}
                />
              </InputGroup>
            </Form.Group>
            <div className="overflow-auto" style={{ maxHeight: "350px" }}>
              {data ? (
                Object?.values(data?.result)?.map((item) => (
                  <div
                    className="border-bottom p-2  rounded "
                    style={{ cursor: "pointer" }}
                    onClick={() => handleSwitchAccount(item)}
                  >
                    <strong>{item?.name}</strong> {item?.accountID}
                  </div>
                ))
              ) : Error ? (
                <h6 className=" p-2 mb-0 text-center" style={{ color: "red" }}>
                  {Error}
                </h6>
              ) : spinner ? (
                <div className=" p-2 mb-0 text-center">
                  <l-line-spinner
                    size="25"
                    stroke="3"
                    speed="1"
                    color="black"
                  ></l-line-spinner>
                </div>
              ) : (
                ""
              )}
            </div>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}
